import { Grid } from '@m/alchemy-ui/Grid';
import { GridCol } from '@m/alchemy-ui/GridCol';
import { GridRow } from '@m/alchemy-ui/GridRow';

import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { typeStyle, units } from '@m/alchemy-ui/theme';
import { SelectorType } from '../../../common/enums';
import { AccessSelector, UserCreatedAccessOptions } from '../components';

const Title = styled.div`
  ${typeStyle('headerS')};
  margin-bottom: ${units(2)};
`;

export interface UserChallengeAccessProps {
  readonly creatorUserId?: string;
}

export const UserChallengeAccess = ({ creatorUserId }: UserChallengeAccessProps) => {
  return (
    <div>
      <Grid>
        <GridRow>
          <GridCol span={{ small: 12, medium: 4, large: 4 }}>
            <Title>
              <FormattedMessage id="access" defaultMessage="Challenge access" />
            </Title>
            <AccessSelector type={SelectorType.CHALLENGE} creatorUserId={creatorUserId} />
          </GridCol>
          <GridCol span={{ small: 12, medium: 8, large: 8 }}>
            <UserCreatedAccessOptions />
          </GridCol>
        </GridRow>
      </Grid>
    </div>
  );
};
